import Vue from 'vue'
import Vuex from 'vuex'
import MetadataService from '../service/metadata.service'
import axios from 'axios'
import config from '../config'
import QueryUtils from '../query-utils'

Vue.use(Vuex)

/**
 * Add the protocol if missing
 */
const prepareUrl = url => url.startsWith('http') ? url : 'https://' + url

/**
 * Send a request to the backend for a given url, which should return an object with all the metadata it could find
 * It build a metadata object with the needed metadata fields
 */
const fetchMetadataFromBackend = (url) => axios
  .post(`${config.getRootApi()}/search/metadata`, { url: url })
  .then(result => result.data)

const buildMetadataFromBackend = (url, defaultMetadata) => fetchMetadataFromBackend(url)
  .then(result => MetadataService.buildMetadata(result, url, defaultMetadata))

/**
 * Fetch the html page for the given url, parse all the metadata
 * It build a metadata object with the needed metadata fields
 */
const fetchMetadataFromFrontend = (url) => QueryUtils
  .fetchWithTimeout(url, { timeout: 3000 })
  .then(response => response.text())
  .then(html => MetadataService.extractMetadata(html))

const buildMetadataFromFrontend = (url, defaultMetadata = {}) => fetchMetadataFromFrontend(url)
  .then(data => MetadataService.buildMetadata(data, url, defaultMetadata))

const fetchMetadata = (url) => {
  const isIndosuez = url.includes('ca-indosuez.com')
  const defaultMetadata = isIndosuez ? MetadataService.buildFakeIndosuezMetadata(url) : {}
  return buildMetadataFromBackend(url, defaultMetadata).catch(() => {
    if (isIndosuez) {
      return buildMetadataFromFrontend(url, defaultMetadata).catch(() => defaultMetadata)
    }
  })
}

const actions = {
  async searchMetadata(_, url) {
    url = prepareUrl(url)
    return fetchMetadata(url)
  },
  async testMetadata(_, url) {
    url = prepareUrl(url)
    const fake = url.includes('ca-indosuez.com') ? MetadataService.buildFakeIndosuezMetadata(url) : {}
    const [result, backAll, frontAll] = await Promise.all([
      fetchMetadata(url).catch(e => ({ error: e })),
      fetchMetadataFromBackend(url).catch(e => ({ error: e })),
      fetchMetadataFromFrontend(url).catch(e => ({ error: e }))
    ])
    return {
      result: {
        metadata: result
      },
      fake: {
        metadata: fake
      },
      backend: {
        all: backAll,
        metadata: MetadataService.buildMetadata(backAll, url)
      },
      frontend: {
        all: frontAll,
        metadata: MetadataService.buildMetadata(frontAll, url)
      }
    }
  }
}

export default {
  state: {},
  getters: {},
  mutations: {},
  actions
}
